import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { IMAGES } from '../../data/images';
import { STATS } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function Hero() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-navy-950" data-id="element-119" data-mp="eo2f1g2bt3v3">
      <img src={IMAGES.hero} alt={t.hero.heroImageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-120" data-mp="aq4rsis48ruc" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/92 to-navy-950/40" aria-hidden="true" data-id="element-121" data-mp="qdxoi7gweus" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-navy-950 to-transparent" aria-hidden="true" data-id="element-122" data-mp="3rxysircas1my" />

      <div className="relative mx-auto max-w-container px-6 pt-24 pb-16 lg:pt-32 lg:pb-24" data-id="element-123" data-mp="1v20xyk94p7ik">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-3xl" data-id="element-124" data-mp="1q3hecqi0c7td">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-[10px] font-semibold uppercase tracking-widest2 text-gold" data-id="element-125" data-mp="1cy6cy2mposzm">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-126" data-mp="1hzc6u3s3ymaq" />
            {t.hero.badge}
          </div>

          <h1 className="mt-8 font-display text-4xl font-medium leading-[1.08] text-white sm:text-5xl lg:text-[4.25rem]" data-id="element-127" data-mp="2alx5zqets2ou">
            {t.hero.titleTop}
            <span className="block text-gold-light" data-id="element-128" data-mp="1vw92cij68rxy">{t.hero.titleAccent}</span>
          </h1>

          <p className="mt-8 max-w-2xl text-base leading-relaxed text-navy-100/75 lg:text-lg" data-id="element-129" data-mp="20usrsswz4lv2">
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row" data-id="element-130" data-mp="2ojv6brwb9ylc">
            <Link to="/contact" className="group inline-flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.16em] text-navy transition-all duration-300 hover:bg-gold-light hover:shadow-lift" data-id="element-131" data-mp="2tdzgsl4scor6">
              {t.hero.ctaPrimary}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-132" data-mp="2u9jizrj56lqe" />
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.16em] text-white transition-all duration-300 hover:border-gold hover:text-gold" data-id="element-133" data-mp="2kbdmxqk0o9tg">
              {t.hero.ctaSecondary}
            </Link>
          </div>
        </motion.div>

        <motion.dl initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-20 grid grid-cols-2 gap-8 border-t border-white/10 pt-10 lg:grid-cols-4" data-id="element-134" data-mp="21kvvrqeu1ma7">
          {STATS.map(s => <div key={s.label.en} data-id="element-135" data-mp="m0d5au1t3mdr">
              <dt className="sr-only" data-id="element-136" data-mp="m1ernuo9vvas">{s.label[lang]}</dt>
              <dd data-id="element-137" data-mp="q1f5bd3js2gs">
                <span className="block font-display text-3xl font-medium text-gold-light lg:text-4xl" data-id="element-138" data-mp="q1yosy8uiywx">
                  {s.value}
                </span>
                <span className="mt-2 block text-[11px] uppercase tracking-[0.16em] text-navy-100/60" data-id="element-139" data-mp="3pepn9k14lnhe">
                  {s.label[lang]}
                </span>
              </dd>
            </div>)}
        </motion.dl>
      </div>
    </section>;
}